import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, BrowserRouter as Router, Navigate, useNavigate } from 'react-router-dom';
import Dashboard from './pages/dashboard';
import ProductionEventPage from './pages/events';
import PageNotFound from './pages/shared/PageNotFound';
import { isIos, logout, resetAllState } from './utils/commonServices';
import ReactGA from "react-ga4";
import SignUp from './pages/unauth/signup';
import SignIn from './pages/unauth/signin';
import ForgotPassword from './pages/unauth/forgotpassword';
import ResetPassword from './pages/unauth/resetpassword';
import ResendLink from './pages/unauth/resendlink';
import { updateUserState } from './redux/userSlice';
import VoiceProfileManager from './pages/events/components/voiceProfile/components/VoiceProfileManager';
import { checkUserButterflyAccess, getUserRoles } from './pages/dashboard/actions';
import NoAccessPage from './pages/shared/NoAccessPage';
import useAuthFlow from './pages/unauth/hooks/useAuthFlow';
import { redirect } from 'react-router-dom';
import { Backdrop, CircularProgress, Typography } from '@mui/material';
import CommonLoader from './pages/eventcreation/components/CommonLoader';
import Logout from './pages/shared/AuthRedirect';
import AuthRedirect from './pages/shared/AuthRedirect';
import { updateCommonState } from './redux/commonSlice';

// import { useSelector } from 'react-redux';

//lucimoments -----------------------
// const GOOGLE_ANALYTICS_ID="G-WT87Y5QVPK"

//localhost ----------------------------
// const GOOGLE_ANALYTICS_ID="G-L29SNM4Y46"

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID)
// ReactGA.initialize([
//   {
//     trackingId: process.env.GOOGLE_ANALYTICS_ID
//   }
// ])

function App() {

   
   const userReducer = useSelector((state) => state.persistedReducers.userReducer);
   const commonReducer = useSelector((state) => state.commonReducer);
   
    const dispatch = useDispatch()
    // const {checkUserButterflyAccess} = useAuthFlow()
    


   useEffect(()=> {
    setTimeout(()=> {
      if(!!window.localStorage.getItem('token')) {
        dispatch(updateUserState({ is_logged: true }));
        checkUserButterflyAccess(dispatch)
      } else {
        
        if(commonReducer.logout_all) {
          dispatch(updateCommonState({ logout_all: false }));
          console.log("logout butetrfly", commonReducer.logout_all)
        //  dispatch(updateUserState({ is_logged: false }));
          window.location.href=`${process.env.REACT_APP_LUCIHUB_URL}/auth-redirect?request=logout`;
          resetAllState(dispatch);
        } else {
          if(commonReducer.logout_from_luci){
            dispatch(updateCommonState({logout_from_luci: false}))
            window.location.href = `${process.env.REACT_APP_LUCIHUB_URL}`
          } else {
                window.location.href=`${process.env.REACT_APP_LUCIHUB_URL}/auth-redirect?request=login`;
          }
          //console.log("login butetrfly", `${process.env.REACT_APP_LUCIHUB_URL}/auth-redirect?request=login`)
         
        }
        
      }
    }, 1500)
   
   },[window.localStorage.getItem('token')])


   const [token, setToken] = useState(window.localStorage.getItem('token'));
   const [loading, setLoading] = useState(false)



  return (<>
      <Router >
          {
            userReducer?.page_loading == true  ? <></> :
          !userReducer.is_logged ?  <Routes>
          <Route path= '/' element={<Navigate to='/redirect' />} />  
          <Route path='/redirect' element={ <AuthRedirect/> } />
      
          <Route path='*' element={ <PageNotFound/> } />
        </Routes> :
        
          <Routes>
             <Route path= '/' element={<Navigate to='/dashboard' />} /> 
            <Route path='/dashboard' element={ <Dashboard/> } />
            <Route path='/voiceprofiles' element={ <VoiceProfileManager/> } />
            <Route path='/no-access' element={ <NoAccessPage/> } />
           
            <Route path='/redirect' element={ <AuthRedirect/> } />
            <Route path='/productionevent/:projectId' element={ <ProductionEventPage/> } />
            <Route path='*' element={ <PageNotFound/> } />
            {/* <Route path= '*' element={<Navigate to='/error-notfound-redirect' />} />  */}
          </Routes>  
        
        }
      </Router>
       
        
    </>);
}

export default App;
